module.exports = __webpack_public_path__ + "static/social-ababc25a3ec6b986a49603c34f9d094b.svg";